export enum GanttStatus {
    NotStarted = "not_started",
    InProgress = "in_progress",
    Completed = "completed",
    Delayed = "delayed",
}
